import type { NoteId } from '@/types/note';

/**
 * Cryptographic randomUUID with a fallback for environments without
 * crypto.randomUUID (older Safari, Firefox in some configs). The fallback is
 * not cryptographically secure but is unique enough for a client-side app.
 */
export function newNoteId(): NoteId {
  const raw =
    typeof globalThis.crypto !== 'undefined' && typeof globalThis.crypto.randomUUID === 'function'
      ? globalThis.crypto.randomUUID()
      : fallbackUuid();
  return raw as NoteId;
}

export function asNoteId(raw: string): NoteId {
  return raw as NoteId;
}

function fallbackUuid(): string {
  // RFC4122 v4-ish; not crypto-strong. Sufficient for demo/local IDs.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
